export const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID;
export const SVG_ASSERT_URL = `https://assets.kula.ai/images/static/core-web/svg`;
export const SUPPORT_HOME_URL = `https://support.kula.ai`;
export const SUPPORT_JOB_URL = `https://support.kula.ai/collections/8017116862-jobs_openings`;
export const SUPPORT_JOB_BOARDS_URL = `https://support.kula.ai/collections/2019036941-job-boards`;
export const SUPPORT_WEBHOOKS_URL = `https://developers.kula.ai/docs/webhook-guides/setup`;
export const SUPPORT_PUBLIC_API_DOCUMENTATION_URL = `https://developers.kula.ai/docs/getting-started/overview`;

// Offices, departments and custom-field definitions are admin-managed config,
// so a page revisit inside this window reuses the cache instead of refetching.
export const FILTER_OPTIONS_STALE_SECONDS = 10 * 60;
export const FILTER_OPTIONS_STALE_MS = FILTER_OPTIONS_STALE_SECONDS * 1000;
// RTK Query hook options for those lists. Every api in `src/store/query` sets
// `refetchOnMountOrArgChange: true`, so `keepUnusedDataFor` alone keeps the data
// but still refetches on each mount; this reuses it inside the window instead.
// Writes invalidate the lists' tags, which refetches regardless.
export const FILTER_OPTIONS_QUERY_OPTIONS = {
  refetchOnMountOrArgChange: FILTER_OPTIONS_STALE_SECONDS,
};

// Account-level switches that a user flips once and then effectively never
// touches — the PAT org kill-switch, "job profiles enabled". Their queries are
// subscribed from the settings shell, so at the default staleTime of 0 they
// refetch on every settings render and navigation. Every writer of these values
// invalidates or writes its query key directly, and both bypass staleTime, so
// the user who makes a change still sees it immediately.
export const STATIC_ACCOUNT_SETTING_STALE_MS = 5 * 60 * 1000;
